export function FilterValidationAlert({
  messages,
  title = "Fix filters before exporting",
}: {
  messages: string[];
  title?: string;
}) {
  if (messages.length === 0) return null;

  return (
    <div
      className="rounded-lg border border-amber-200 bg-amber-50 px-3 py-2.5 text-sm text-amber-950"
      role="alert"
    >
      <p className="font-semibold">{title}</p>
      <ul className="mt-1.5 list-disc space-y-0.5 pl-4 text-[0.82rem] leading-relaxed">
        {messages.map((msg) => (
          <li key={msg}>{msg}</li>
        ))}
      </ul>
    </div>
  );
}
